/**
 * Lease Analysis API — tenant tenure, retention, and survival metrics.
 */
import { fetchWithAuth } from './api';

const API_URL = '/api/data/analytics/lease-analysis';

export const fetchLeaseAnalysis = async (params = {}) => {
  const query = new URLSearchParams();
  if (params.owner) {
    query.set('owner', params.owner);
  }
  if (params.includeTruncated === false) {
    query.set('include_truncated', 'false');
  } else if (params.includeTruncated === true) {
    query.set('include_truncated', 'true');
  }
  const qs = query.toString();
  const response = await fetchWithAuth(qs ? `${API_URL}?${qs}` : API_URL, {
    signal: params.signal,
  });
  if (!response || !response.ok) {
    const body = response ? await response.json().catch(() => ({})) : {};
    throw new Error(body.error || 'Failed to load lease analysis');
  }
  return response.json();
};
